import QRCodeStyling from 'qr-code-styling';

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.wp-block-kodionica-qr-code-generator .qr-code-wrapper' ).forEach( wrapper => {
		const options = wrapper.dataset.qrOptions ? JSON.parse( wrapper.dataset.qrOptions ) : {};
		const qrCode = new QRCodeStyling( getQRCodeSettings( options ) );
		qrCode.append( wrapper );
	} );
} );

export function getQRCodeSettings( data ) {
	const {
		value,
		size,
		margin,
		typeNumber = '7',
		errorCorrectionLevel = 'Q',
		bgColor,
	} = data;

	return {
		'type': 'canvas',
		'data': value || window.location.href,
		'width': size,
		'height': size,
		margin,
		qrOptions: {
			typeNumber,
			errorCorrectionLevel
		},
		backgroundOptions: {
			'color': bgColor
		}
	};
}
